import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { Router, RouterModule } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { HeaderService } from 'src/app/shared/services/header.service';
import { Select } from '@ngxs/store';
import { ProjectsState } from '../../project.state';
import { map, Observable, of } from 'rxjs';
import { ProjectModel } from '../../project.models';
import { AlertService, ButtonColors, ButtonModule } from '@ed---interne/ng-uui-components';

interface MenuItem {
    display: string;
    routerLink: any[];
    routerLinkActiveOptions?: any;
}

@UntilDestroy()
@Component({
    selector: 'project-read',
    templateUrl: './project-read.component.html',
    styleUrls: ['./project-read.component.scss'],
    standalone: true,
    schemas: [],
    imports: [CommonModule, SharedModule, RouterModule, ButtonModule],
    providers: [],
})
export class ProjectReadComponent {
    public buttonColors = ButtonColors;
    public menuItems$: Observable<MenuItem[]> | undefined;
    @Select(ProjectsState.projectWithDetail)
    public project$!: Observable<ProjectModel>;
    public project: ProjectModel | undefined;

    constructor(
        private readonly router: Router,
        private readonly sidenavService: SidenavService,
        private readonly headerService: HeaderService,
        private readonly alertService: AlertService,
    ) {
        this.project$.pipe(untilDestroyed(this)).subscribe((project: ProjectModel) => {
            if (!project) return;
            this.project = project;
            this.headerService.setBreadcrumbs([
                { link: '/main/projects/all', label: 'Projets' },
                { label: `${project.code} - ${project.label}` },
            ]);

            this.sidenavService.resetSubMenuItem('Projets', [
                {
                    label: `Tous les projets`,
                    icon: 'bi bi-folder2-open',
                    routerLink: [`/main/projects`],
                    routerLinkActiveOptions: { exact: true },
                    hidden: false,
                    isActive: false,
                    subItems: [],
                },
                {
                    label: `${project.code} - ${project.label}`,
                    icon: 'bi bi-file-earmark-text',
                    routerLink: [`/main/projects/${project.code}`],
                    routerLinkActiveOptions: { exact: true },
                    hidden: false,
                    isActive: false,
                    subItems: [],
                },
            ]);

            const sum =
                this.project.billingMilestones?.reduce((acc, b) => acc + b.amountExclTax, 0) || 0;
            if (sum !== this.project.soldAmount) {
                this.alertService.warning(
                    `Le planning de facturation  ne correspond pas au montant total de la mission (${sum.toLocaleString()}€ VS ${(this.project?.soldAmount || 0).toLocaleString()}€ )`,
                    'Merci de le mettre à jour au plus vite',
                    60000,
                );
            }
        });

        this.menuItems$ = of(null).pipe(
            map(() => {
                const items = [
                    {
                        display: 'Général',
                        routerLink: ['./general'],
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        display: 'Facturation',
                        routerLink: ['./billing'],
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        display: 'Sous-traitance',
                        routerLink: ['./subcontracting'],
                        routerLinkActiveOptions: { exact: false },
                    },
                    {
                        display: 'Temps passés',
                        routerLink: ['./timesheets'],
                        routerLinkActiveOptions: { exact: false },
                    },
                ];

                return items;
            }),
            untilDestroyed(this),
        );
    }
    public editProject() {
        if (!this.project) return;
        const code = this.project.code;
        this.router.navigate([`/main/projects/${code}/edit`]);
    }
}
